import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ScrollbarModule } from 'src/@fury/shared/scrollbar/scrollbar.module';

import { ChatMessageComponent } from './message.component';
import { AvatarDisplayModule } from '../../avatar/avatar-display/avatar-display.module';

@NgModule({
  declarations: [ChatMessageComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,

    MatFormFieldModule,
    MatListModule,
    MatProgressBarModule,
    MatSidenavModule,
    MatInputModule,
    MatButtonModule,

    ScrollbarModule,
    MatIconModule,
    AvatarDisplayModule
  ],
  exports: [ChatMessageComponent]
})
export class ChatMessageModule {}
